import { render, staticRenderFns } from "./wordsBreakThroughUnit.vue?vue&type=template&id=4c16461a&scoped=true&"
import script from "./wordsBreakThroughUnit.vue?vue&type=script&lang=js&"
export * from "./wordsBreakThroughUnit.vue?vue&type=script&lang=js&"
import style0 from "./wordsBreakThroughUnit.vue?vue&type=style&index=0&id=4c16461a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c16461a",
  null
  
)

export default component.exports